import React from 'react';
import PropTypes from 'prop-types';

export default class UserTackProgress extends React.Component {
  static propTypes = {
    currentInterval: PropTypes.number
  }

  render() {
    const intervals = [1,2,3,5,8,13];
    const intervalNodes = intervals.map((interval) => {
      if (this.props.currentInterval === interval) {
        return (
          <li key={ interval }>
            <span title={`Day ${ interval }`} className={ `interval-point interval-next interval-${ interval }` }>&nbsp;</span>
          </li>
        );
      }
      else if (this.props.currentInterval >= interval) {
        return (
          <li key={ interval }>
            <span title={`Day ${ interval }`} className={ `interval-point interval-completed interval-${ interval }` }>&nbsp;</span>
          </li>
        );
      } else {
        return (
          <li key={ interval }>
            <span title={`Day ${ interval }`} className={ `interval-point interval-pending interval-${ interval }` }>&nbsp;</span>
          </li>
        );
      }
    });
    return (
      <ul className='tack-progress'>
        { intervalNodes }
      </ul>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/user_tack_progress.jsx